import { useState } from 'react';
import useFetch from '../../../hooks/useFetch';
import { buildEndpoint } from '../EndPoints';
import { ServiceEvents } from '../shared/interfaces';

const useContractFieldService = () => {
    const { doGet, doPost } = useFetch();
    
    const [fetchingAll, setFetchingAll] = useState(false);
    const [fetchingStore, setFetchingStore] = useState(false);
    const [fetchingUpdate, setFetchingUpdate] = useState(false);
    const [fetchingDelete, setFetchingDelete] = useState(false);
    
    const getAllFields = (contractTypeId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`app/contract-drafting/admin/contract-types/${contractTypeId}/fields`),
            setFetching: setFetchingAll
        });
    };
    
    const storeField = (data: any, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint('app/contract-drafting/admin/fields/store'),
            body: data,
            setFetching: setFetchingStore
        });
    };
    
    const updateField = (id: number, data: any, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`app/contract-drafting/admin/fields/${id}/update`),
            body: data,
            setFetching: setFetchingUpdate
        });
    };
    
    const deleteField = (id: number, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`app/contract-drafting/admin/fields/${id}/delete`),
            setFetching: setFetchingDelete
        });
    };
    
    return {
        fetchingAll,
        fetchingStore,
        fetchingUpdate,
        fetchingDelete,
        getAllFields,
        storeField,
        updateField,
        deleteField
    };
};

export default useContractFieldService;

